<template>
    <FundPanel cardId="card-pension" :alerts="alerts">
        <template #icon>
            <i class="iatse-icon-egg-basket"></i>
        </template>
        <template #title>
            Pension
        </template>
        <template #fund-cover>
            <div class="col-md-9">
                <div class="fund-cover fund-cover__pension" :class="{ 'pdt-30 pdb-30': isPensioner }">
                    <div v-if="hasPaymentsOnHold" class="coverage-column w-100 mb-30">
                        <span class="label label_danger pdl-40 pdr-40 sm-pdr-10 sm-pdl-10"> Pension
                            Payments
                            on Hold -
                            Please Call Us at 800-456-3863
                        </span>
                    </div>
                    <div class="fund-cover-header">
                        <div class="coverage-column" :class="{ 'flex-grow-1': isPensioner }">
                            <div class="fund-cover-row">
                                <i class="iatse-icon-clipboard-tick"></i>
                                <p class="links">Pension Benefit Status:
                                    <span class="tooltip-wrapper">
                                        <i class="iatse-icon-square-info icon_rotate_0"></i>
                                            <div class="tooltip-text tooltip-text_secondary tooltip-text__xlarge card-body d-flex flex-column gap-4 sm-fs-xxs">
                                                <h4 class="text-white">I.A.T.S.E. NATIONAL PENSION FUND</h4>
                                                <span>
                                                    This Pension Credit History & Estimated Benefit Statement is based upon current Plan provisions and benefit levels and the service data in the Fund’s records at the time of your request. It is an estimate for your general information only. The information has not been verified and does not necessarily mean that you have a vested benefit. Your actual entitlement to benefits will, of course, depend upon the final components of the calculation, such as, for example, your years of service, age, marital status and the form in which you elect to receive your benefits when you are eligible to receive them.
                                                </span>
                                                <span>
                                                    The Trustees reserve the right to correct any discrepancies in this estimate. Only the full Board of Trustees of the Plan has the authority to make a definite, official determination of your status and to approve or deny an application for benefits.
                                                </span>
                                                <span>
                                                    <i>If you believe you are entitled to credit for work that is not reflected in the Fund’s records, it is your responsibility to provide documentation supporting that claim.</i>
                                                </span>
                                                <span>
                                                    This statement does not in any way modify the Rules and Regulations of the Plan, including but not limited to the rules concerning vesting and breaks in service. Your Summary Plan Description booklet contains a summary of the Rules and Regulations and should be referred to for a general description of Plan provisions including but not limited to how benefit credits are earned and the eligibility rules for receiving Pension benefits. Other important Plan features such as the Husband & Wife election/waiver, early retirement rules, etc. are also described therein. If you do not have a Plan booklet, you can obtain one by writing to the Pension Fund Office at the address below, by calling us at 1-800-456-FUND (3863), or by visiting our website at <a :href="baseUrl" target="_blank" class="text-white">www.iatsenbf.org</a>.
                                                </span>
                                                <span>
                                                    If there is a discrepancy between the Rules and Regulations of the Plan, the Summary Plan Description and the information contained in this statement, the provisions contained in the Rules and Regulations of the Plan will govern.
                                                </span>
                                            </div>
                                    </span>
                                </p>
                            </div>
                            <p>
                                <strong>{{ loading ? '...' : status }}</strong>
                                <small v-if="isPensioner"> {{ loading ? '' : date }} </small>
                            </p>
                        </div>
                        <div class="divider"> </div>
                        <div class="coverage-column">
                            <div class="fund-cover-row">
                                <i class="iatse-icon-trade"></i>
                                <p class="links">Pension Credits:</p>
                            </div>
                            <p class="">
                                <template v-if="creditsUnderMaintenance">
                                    <strong>Temporarily unavailable</strong>
                                </template>

                                <template v-else-if="mode === PensionMode.SUBMISSION">
                                    <strong>
                                    <span  class="tooltip-wrapper">
                                        <i class="iatse-icon-info-tooltip icon_rotate_0"></i>
                                        <p class="tooltip-text tooltip-text_secondary">
                                            Click the ‘Pension Credit History’ button to submit a request to the Fund Office for a Pension Credit History Report.
                                        </p>
                                    </span>
                                    </strong>
                                </template>
                                <template v-else>
                                    <strong>{{ loading ? '...' : pensionCredits }}</strong>
                                    <small>{{ loading ? '' : date }}</small>
                                </template>
                            </p>
                        </div>
                        <div class="divider"> </div>
                        <div class="coverage-column" :class="{ 'mt-30 sm-mt-10': isPensioner }">
                            <div class="fund-cover-row">
                                <i class="iatse-icon-trade"></i>
                                <p class="links">Vested Credits: 
                                    <!-- <i class="iatse-icon-square-info"></i> -->
                                    <span v-if="mode === PensionMode.SUBMISSION" class="tooltip-wrapper">
                                        <i class="iatse-icon-info-tooltip icon_rotate_0"></i>
                                        <p class="tooltip-text tooltip-text_secondary">
                                            Click the ‘Pension Credit History’ button to submit a request to the Fund Office for a Pension Credit History Report.
                                        </p>
                                    </span>
                                </p>
                            </div>
                            <p class="">
                                <template v-if="creditsUnderMaintenance">
                                    <strong>Temporarily unavailable</strong>
                                </template>

                                <template v-else-if="mode === PensionMode.SUBMISSION">
                                    <strong></strong>
                                    <small>{{ loading ? '' : '' }}</small>
                                </template>
                                <template v-else>
                                    <strong>{{ loading ? '...' : vestedCredits }}</strong>
                                    <small>{{ loading ? '' : date }}</small>
                                </template>
                            </p>
                        </div>
                        <div v-if="isPensioner" class="divider"> </div>
                        <div v-if="isPensioner" class="coverage-column gap-0 sm-gap-10 align-items-md-center align-items-start">
                            <div class="fund-cover-row col-md-5 justify-content-start">
                                <i class="iatse-icon-map"></i>
                                <p class="plan-modal links text-underline sm-fs-sm" @click="openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'pension')">
                                    Pension Check Destination: </p>
                            </div>
                            <p><strong>{{ checkDestination ?? '-' }}</strong></p>
                        </div>
                    </div>
                    <div v-if="creditsUnderMaintenance" class="info_card info_card__danger mb-30 ml-10" style="max-width: 50%;">
                        <span>
                            The Pension Credits History page is currently under maintenance. We apologize for the inconvenience. If you need your Pension Credits History while the page is unavailable, please contact the Fund Office for assistance.
                        </span>
                    </div>
                    <div class="fund-cover-buttons">
                        <a href="" class="btn btn-primary plan-modal" :class="{ 'mr-20 sm-mr-0': isPensioner }"
                            @click.prevent="openModal('work-history', 'Pension Work History', null, 'pension', null, null, undefined, { Funds: [1, 2, 9] })">
                            Work History
                        </a>
                        <a
                            v-if="mode === PensionMode.SUBMISSION"
                            href=""
                            class="btn btn-secondary plan-modal mr-20 sm-mr-0"
                            :aria-disabled="!mode"
                            @click.prevent="
                                openModal(
                                    'request-pch',
                                    'Pension Credits History Request Confirmation',
                                    'plan-profile plan-tables pension-credits',
                                    'pension',
                                    null,
                                    'Pension Credit History'
                                )
                            "
                        >
                            Pension Credit History
                        </a>
                        <a
                            v-else-if="isPensioner"
                            href=""
                            class="btn btn-secondary plan-modal mr-20 sm-mr-0"
                            :class="{ disabledcredit: creditsUnderMaintenance }"
                            :aria-disabled="creditsUnderMaintenance || !mode"
                            @click.prevent="
                                !creditsUnderMaintenance &&
                                openModal(
                                    'pension-credits-history',
                                    'Pension',
                                    'plan-profile plan-tables pension-credits',
                                    'pension',
                                    null,
                                    'Pension Credit History'
                                )
                            "
                        >
                            Pension Credit History
                        </a>
                        <a
                            v-else
                            href=""
                            class="btn btn-secondary plan-modal mr-20 sm-mr-0"
                            :class="{ disabledcredit: creditsUnderMaintenance }"
                            :aria-disabled="creditsUnderMaintenance || !mode"
                            @click.prevent="
                                !creditsUnderMaintenance &&
                                openModal(
                                    'pension-credits-history',
                                    'Pension Credit History',
                                    'plan-profile plan-tables pension-credits',
                                    'pension'
                                )
                            "
                        >
                            Pension Credit History
                        </a>
                        <a v-if="isPensioner" href="" class="btn btn-secondary plan-modal" @click.prevent="openModal(
                            'pensioner-profile', 'Pension', 'plan-profile plan-tables pension-credits', 'pension', null, 'Pensioner Profile',
                            [{
                                name: 'View Pension Credit History', title: 'Pension > Pensioner Profile', secondTitle: 'Pension Credit History',
                                    action: 'pension-credits-history', classes: 'plan-profile plan-tables pension-credits',
                                    type: 'secondary'
                                }, {
                                name: 'Work History', title: 'Pension > Pensioner Profile', secondTitle: 'Pension Work History', action: 'work-history', classes: '', queryParams: { Funds: [1, 2, 9] },
                                type: 'secondary'
                            }])">
                            View Profile
                        </a>
                    </div>
                </div>
            </div>
        </template>
        <template #related-links>
            <template v-if="isPensioner">
                <button class="btn btn-tertiary btn-large plan-modal"
                    @click="openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'pension')">
                    ACH/Check Destination</button>
                <button v-if="hasChecks" class="btn btn-tertiary btn-large plan-modal"
                    @click="openModal('check-replacement', 'Check Replacement', 'plan-form', 'pension')">
                    Check Replacement
                </button>
            </template>
            <template v-else>
                <a href="" class="btn btn-tertiary btn-large plan-modal"
                    @click.prevent="openModal('pension-application', 'Pension Application', 'plan-form', 'application')">Pension
                    Application
                </a>
                <a href="" class="btn btn-tertiary btn-large plan-modal"
                    @click.prevent="openModal('pension-application', 'Estimate Request', 'plan-form', 'estimate')">
                    Estimate Request
                </a>
            </template>

            <a href="" class=" btn btn-tertiary btn-large plan-modal" @click.prevent="openModal('add-beneficiary',
                'My Beneficiary(ies)',
                'plan-tables-striped beneficiary',
                null,
                null,
                null,
            )">
                Beneficiary(ies)
            </a>
            <a href="" @click.prevent="openModal('plan-resources', 'Pension Fund Resources', null, 'pension')" class="btn btn-tertiary btn-large plan-modal">Fund's Resources</a>
        </template>
    </FundPanel>
</template>

<script lang="ts">
import { defineComponent, ref, Ref, toRefs, computed, onMounted, reactive } from 'vue';
import { PensionDashboardInfo, PensionPlan, Alert } from '@/interfaces/interfaces';
import { PensionStatus } from '@/interfaces/pension';
import { useModalStore } from '@/stores/modal';
import { usePensionStore } from '@/stores/pension';
import { useDateFormatter } from '@/utils/dateFormatter';
import { PensionMode } from '@/enums/PensionMode';
import FundPanel from '@/components/cards/FundPanel.vue';
import axios from 'axios';

export default defineComponent({
    props: {
        alerts: {
            type: Array as () => Alert[],
            required: true
        },
    },
    components: {
        FundPanel,
    },
    setup(props) {
        const loading = ref(true);
        const modalStore = useModalStore();
        const pensionStore = usePensionStore();
        const isPensioner = computed(() => pensionStore.pensionerDetails?.IsPensioner);
        const mode = computed(() => pensionStore.mode);
        const hasChecks = computed(() => pensionStore.pensionerDetails?.HasChecks);
        const checkDestination = computed(() => pensionStore.pensionerDetails?.CheckDestination?.Destination);
        const hasPaymentsOnHold = computed(() => pensionStore.pensionerDetails?.HasPaymentsOnHold);
        const vestedCredits = computed(() => pensionStore.data?.totalVestingCredits ? pensionStore.data?.totalVestingCredits : 0);
        const pensionCredits = computed(() => pensionStore.data?.totalPensionCredits ? pensionStore.data?.totalPensionCredits : 0);
        const status = computed(() => {
            if (isPensioner.value && pensionStore.pensionerDetails?.BenefitStatus) {
                return pensionStore.pensionerDetails?.BenefitStatus;
            } else if (pensionStore.data?.vestingYear && pensionStore.data?.vestingYear <= new Date().getFullYear()) {
                return 'Vested';
            }
            return 'Not Vested';
        });

        const date = computed(() => {
            if (isPensioner.value) {
                return '';
            }

            return pensionStore.data?.responseDateTime ? ' (as of ' + useDateFormatter(pensionStore.data?.responseDateTime) + ')' : '';
        })

        const creditsUnderMaintenance = computed(() => pensionStore.creditsUnderMaintenance);

        const fetchData = async () => {
            loading.value = true;

            if (!pensionStore.data) {
                await pensionStore.fetchPensionCredits();
            }

            loading.value = false;
        };

        onMounted(fetchData);

        return {
            PensionMode,
            mode,
            hasPaymentsOnHold,
            checkDestination,
            isPensioner,
            hasChecks,
            loading,
            status,
            date,
            vestedCredits,
            pensionCredits,
            creditsUnderMaintenance,
            useDateFormatter,
            openModal: modalStore.openModal,
            baseUrl: process.env.VUE_APP_PUBLIC_URL
        };
    }
});
</script>

<style scoped>
    .disabledcredit {
        color: grey;
    }
</style>